module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('p', [_vm._v("This is the toplevel page of the jonnypickett site.")]), _vm._v(" "), _c('p', [_vm._v("I am a software engineer, a family man, a baseball fan, and an art appreciator.")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("I really love film. Take a look at the "), _c('router-link', {
    attrs: {
      "to": "/last-ten-films"
    }
  }, [_vm._v("last ten films")]), _vm._v(" I watched.")], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("The "), _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("about")]), _vm._v(" page goes into more detail about who I am."), _c('br'), _vm._v(" The "), _c('router-link', {
    attrs: {
      "to": "/current"
    }
  }, [_vm._v("current projects")]), _vm._v(" page details what I am currently working on,"), _c('br'), _vm._v(" and the "), _c('router-link', {
    attrs: {
      "to": "/resume"
    }
  }, [_vm._v("resume")]), _vm._v(" page has a link to my current resume to give a good overview of my experience.")], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Right now I'm really excited about serverless technologies. I've finally committed to understanding data modeling with NoSQL databases such as DynamoDB. Big ups to "), _c('a', {
    attrs: {
      "href": "https://www.alexdebrie.com",
      "target": "_blank"
    }
  }, [_vm._v("Alex DeBrie")]), _vm._v(" and his "), _c('a', {
    attrs: {
      "href": "https://www.dynamodbbook.com",
      "target": "_blank"
    }
  }, [_vm._v("\"The DynamoDB Book\"")]), _vm._v("."), _c('br'), _vm._v(" I get that engineering high off of working on decoupled, fault-tolerant systems. I'll probably try to convince you that we should use an event based microservice approach as a way to reduce points of failure.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("My favorite baseball team is the "), _c('a', {
    attrs: {
      "href": "https://cdn.kqed.org/wp-content/uploads/sites/10/2014/10/RS12812_458071300-scr.jpg",
      "target": "_blank"
    }
  }, [_vm._v("San Francisco Giants")]), _vm._v(", and yes, the National League is the best league.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("My favorite painting is "), _c('a', {
    attrs: {
      "href": "https://collections.lacma.org/node/233733",
      "target": "_blank"
    }
  }, [_vm._v("Joan Mitchell's East Ninth Street")]), _vm._v(" on display at LACMA.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-178f9a15"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 70
// module chunks = 0